import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import batchImg from '../../assets/images/batches-banner-2.png';
import EditBatchIcon from '../../assets/images/edit-batch.png';
import Select from 'react-select';
import { cx } from '@emotion/css';
import { selectMedium } from '../../styles/components/forms.style';
import * as styles from './batches.style.js';

var Studentmap = {};
function EditBatch(props) {
  const categorytypes = [
    'Mathematics',
    'General Knowledge',
    'Chess',
    'SpellBowl',
  ];
  const history = useHistory();
  const [jwt, set_jwt] = useState('');
  const [email, set_Email] = useState('');
  const [username, set_username] = useState('');


  let data1 = useLocation();

  useEffect(() => {
    ////console.log("useEffect called in EditBatch")
    ////console.log(data1)
    getToken();
    setBatchname(data1.state['name']);
    setCategory(data1.state['category']);
    // console.log(data1.state['students'])
    setItems(data1.state['students']);
    var i;
    Studentmap = {};
    for (i = 0; i < data1.state['students'].length; i++) {
      ////console.log( data1.state["students"][i])
      Studentmap[data1.state['students'][i]] = 'add';
    }
    document.title = 'Edit Batch';

  }, []);

  // const getToken = async () => {
  //   Auth.currentSession().then((res) => {
  //     ////console.log("Auth.currentSession()")
  //     let accessToken = res.getAccessToken();
  //     ////console.log("accessToken called ")
  //     let jwt = accessToken.getJwtToken();
  //     ////console.log("Got jwt ")
  //     let useremail = Auth.user.attributes.email;

  //     set_jwt(jwt);
  //     set_Email(useremail);
  //   });
  // };


  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();
        let useremail = user.attributes['email'];
        set_jwt(jwt);
        set_Email(useremail);


        if (user.username.includes("Google_")) {


          set_username(user.attributes['email'])





        }
        else {

          set_username(user.username)




        }





      });




    } catch (error) {
      // console.log(error)
      Auth.signOut();
    }
  };





  const saveStudents = async (category, id, members, batchname) => {
    createBatch(
      category,
      id,
      members,
      batchname,
      username,
      email,
      jwt
    );
    updateStudents(id, members, jwt);
  };

  const getuserDetails = async (username) => {
    // console.log(username)
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };

    const response = await fetch(
      `https://api.prod.quizwizard.net/quiz/getuser`,
      requestOptions
    );
    const data = await response.json();

    if (data != 'No User') {
      const newItem = inputValue;
      const newItems = [...items, newItem];
      setItems(newItems);
      setInputValue('');
      Studentmap[inputValue] = 'add';
    } else {
      alert('Username not valid. Please verify');
      setInputValue('');
      // console.log('No such User');
    }
  };
  const createBatch = async (
    category,
    id,
    members,
    batchname,
    user,
    useremail,
    jwt
  ) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },

      body: JSON.stringify({
        category: category,
        classowner: username,
        id: id,
        name: batchname,
        email: useremail,
        sendEmail: true,
        members: members,
      }),
    };
    ////console.log(requestOptions)
    const response = await fetch(
      `https://api.prod.quizwizard.net/quiz/createbatch`,
      requestOptions
    );
    const data = await response.json();
    ////console.log(data)
  };

  const updateStudents = async (id, members, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },

      body: JSON.stringify({ id: id, members: Studentmap }),
    };
    ////console.log(requestOptions)
    const response = await fetch(
      `https://api.prod.quizwizard.net/quiz/updatestudentsbatch`,
      requestOptions
    );
    const data = await response.json();
    ////console.log("******")
    ////console.log(data)
    ////console.log("calling history back")
    history.goBack();
  };
  function savestudents() {
    if (items.length > 0) {
      saveStudents(category, data1.state['id'], items, batchname);
    } else {
      setChecks('Add a Student');
    }
  }

  function goback() {
    history.goBack();
  }
  // HINT: each "item" in our list names a name,
  // a boolean to tell if its been completed, and a quantity
  // const [items, setItems] = useState([
  // 	{ itemName: 'Student1', quantity: 1, isSelected: false },
  // 	{ itemName: 'Student2', quantity: 3, isSelected: false },
  // 	{ itemName: 'Student3', quantity: 2, isSelected: false },
  // ]);

  const [items, setItems] = useState([]);
  const [category, setCategory] = useState('');
  const [batchname, setBatchname] = useState('');

  const [inputValue, setInputValue] = useState('');
  const [status, setStatus] = useState('Save Details');

  const [checks, setChecks] = useState('');

  const handleAddButtonClick = () => {
    if (inputValue.trim().length) getuserDetails(inputValue);
  };

  const deleteStudent = (index) => {
    Studentmap[items[index]] = 'remove';
    const newItems = [...items];
    newItems.splice(index, 1);

    //newItems[index].isSelected = !newItems[index].isSelected;

    setItems(newItems);
    //setTotalItemCount(items.length - 1 );
  };
  return (
    <>
      <div className="centerdiv">
        <div className={cx(styles.batchBanner)}>
          <img src={batchImg} alt="" />
        </div>
        <div className={cx(styles.editBatchesMain)}>
          {checks}
          <div className={cx(styles.editBatchIcon)}>
            <img src={EditBatchIcon} alt="" />
          </div>
          <h3>Edit Batch</h3>
          <div className="add-item-box">
            <input
              value={batchname}
              onChange={(event) => setBatchname(event.target.value)}
              className="add-item-input"
              placeholder="Batch Name"
            />
          </div>

          <div className="add-item-box">
            <label htmlFor="">Select Batch</label>
            <Select
              className={cx(selectMedium)}
              classNamePrefix="select"
              name="category"
              options={categorytypes.map((questiontype) => ({
                value: questiontype,
                label: questiontype,
              }))}
              onChange={(e) => setCategory(e.value)}
              value={{ value: category, label: category }}
            />
          </div>
          <div className="add-item-box">
            <input
              value={inputValue}
              onChange={(event) => setInputValue(event.target.value)}
              className="add-item-input"
              placeholder="Add a Student..."
            />
            <span
              onClick={() => handleAddButtonClick()}
              className={cx(styles.addBtn)}
            >
              <FontAwesomeIcon icon={faPlus} />
            </span>
            <div className="item-list">
              {items.map((item, index) => (
                <div className="item-container">
                  <div
                    className="item-name"
                    onClick={() => deleteStudent(index)}
                  >
                    <span className="closeBtn">
                      <FontAwesomeIcon icon={faTimes} />
                    </span>
                    <span>{item}</span>

                    {/* {item.isSelected ? (
									<>
										<FontAwesomeIcon icon={faTimes} />
										<span className='completed'>{item.itemName}</span>
									</>
								) : (
									<>
										<FontAwesomeIcon icon={faTimes} />
										<span>{item.itemName}</span>
									</>
								)} */}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={cx(styles.editBtnFlex)}>
            <button className="popupbutton2" onClick={savestudents}>
              {status}
            </button>
            <button className="popupbutton2" onClick={goback}>
              Go Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditBatch;
